(function () {
  if (window.__cartUpsellsAjaxFixInstalled) return;
  window.__cartUpsellsAjaxFixInstalled = true;

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || form.tagName !== 'FORM') return;
    if (!form.closest('cart-upsells')) return;

    var cartContainer = document.querySelector('cart-container');
    if (!cartContainer || typeof cartContainer.add !== 'function') return;

    event.preventDefault();
    event.stopImmediatePropagation();

    var atcBtn = form.querySelector('.btn-atc') || form.querySelector('[type="submit"]');
    if (atcBtn) {
      atcBtn.style.width = atcBtn.offsetWidth + 'px';
      atcBtn.classList.add('loading');
      atcBtn.disabled = true;
      atcBtn.setAttribute('aria-busy', 'true');
    }

    Promise.resolve(cartContainer.add(new FormData(form)))
      .catch(function (err) { console.error('Cart upsell add error:', err); })
      .finally(function () {
        if (atcBtn) {
          atcBtn.style.width = '';
          atcBtn.classList.remove('loading');
          atcBtn.disabled = false;
          atcBtn.removeAttribute('aria-busy');
        }
      });
  }, true);
})();
